import Hero from "../Components/Hero";

function Landing() {
	return (
		<>
			<Hero />
		</>
	);
}

export default Landing;
